import type { TMessages } from '../../../../types/TMessages'

export const messages = {
  offers: 'Готовые предложения покупателей',
  showAllOffersButton: 'Посмотреть все предложения',
} satisfies TMessages
